'use client';

import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next-nprogress-bar';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'ui';
import type { NormalizedSortBy } from '../_components/types';
import { NORMALIZED_SORT_BY_MAP } from '../_server/sort-map';
import { pathPrefixAtom } from '../../_components/blog-state';
import {
  defaultSortByAtom,
  showSortMenuAtom,
} from '../../_components/design-state';

type SortByMenuProps = {
  index: number;
  tag: string;
  value: NormalizedSortBy;
  design?: boolean;
};

export function SortByMenu({ value, tag, index, design }: SortByMenuProps) {
  const showSortMenu = useAtomValue(showSortMenuAtom);
  const defaultSortBy = useAtomValue(defaultSortByAtom);
  const urlPrefix = useAtomValue(pathPrefixAtom);
  const router = useRouter();
  const t = useTranslations('Blog.SortBy');
  if (!showSortMenu) {
    return null;
  }
  return (
    <Select
      defaultValue={design ? NORMALIZED_SORT_BY_MAP[defaultSortBy] : value}
      disabled={!!design}
      key={defaultSortBy}
      onValueChange={(v) => {
        router.push(`${urlPrefix}/category/${tag}/${index}/${v}#tag-tabs`);
      }}
    >
      <SelectTrigger className="w-45!" aria-label={t('AriaLabel')}>
        <SelectValue placeholder={t('Placeholder')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="most-recent">{t('MostRecent')}</SelectItem>
        <SelectItem value="least-recent">{t('LeastRecent')}</SelectItem>
        <SelectItem value="title-asc">{t('TitleAsc')}</SelectItem>
        <SelectItem value="title-desc">{t('TitleDesc')}</SelectItem>
      </SelectContent>
    </Select>
  );
}
